import Model from './Model';

import CustomRedirectResponse from 'Api/CRM/Responses/CustomRedirectResponse';

export default class CustomRedirect extends Model {
    readonly id: number;
    readonly source_url: string;
    readonly target_url: string;
    readonly status_code: number;
    readonly created_at: string | null;
    readonly updated_at: string | null;

    constructor(menu: Partial<CustomRedirectResponse>) {
        super();
        this.assignDataToProps(menu, ['id', 'source_url', 'target_url', 'status_code', 'created_at', 'updated_at']);
    }
}
